import Table from "@/common/components/Table";
import { WalletWrapper } from "./style";
import { walletData, walletTableHeaders, walletTableKeys } from "./data";
import { useState } from "react";
import { KeyValueObj } from "@/common/types";
import { Modal } from "@/common/components/modal";
import ViewMore from "./viewMore";

export enum IwalletStatus {
  COMPLETED = "completed",
  PENDING = "pending",
  IN_REVIEW = "in_review",
}

export interface IWalletRequest {
  id: string;
  date: string;
  company_name: string;
  company_type: string;
  status: IwalletStatus;
}

const AdminWallet = () => {
  const [currentRow, setCurrentRow] = useState<IWalletRequest | null>(null);
  const [viewMore, setViewMore] = useState<boolean>(false);
  const handleDropdownClick = (row: IWalletRequest) => {
    if (row.id === currentRow?.id) {
      setCurrentRow(null);
    } else {
      setCurrentRow(row);
    }
  };
  return (
    <WalletWrapper>
      <div className="table-wrapper">
        <Table
          tableTitle="Wallet request"
          tableSubtitle="A list of total wallet request"
          tableData={walletData()}
          tableHeaders={walletTableHeaders}
          tableKeys={walletTableKeys}
          showDropDown
          handleDropDownClicked={(row: KeyValueObj) =>
            handleDropdownClick(row as unknown as IWalletRequest)
          }
          dropDownOptions={[{ label: "View", action: () => setViewMore(true) }]}
        />
      </div>
      <Modal
        title="Pending Wallet Request"
        isOpen={viewMore}
        close={() => setViewMore(false)}
      >
        <ViewMore data={currentRow as IWalletRequest} />
      </Modal>
    </WalletWrapper>
  );
};

export default AdminWallet;
